import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { useSelector } from "react-redux";

const MainLayout = () => {
  // Get responsive state from Redux store
  const { isSidebarCollapsed, isResponsiveMode } = useSelector((state) => state.responsive);

  const containerClasses = "flex text-black min-h-[100vh]";
  return (
    <div className={containerClasses}>
      <Sidebar />
      <div className="flex flex-col flex-grow w-full">
        <Navbar />
        <div className="p-4 bg-[#f9f9f9] box-border">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
